@if (items$ | async; as products) {
  <div class="container">
    @for (product$ of products; track product$) {
      @if (product$ | async; as product) {
        <span
          class="item"
      [routerLink]="
        {
          cxRoute: 'product',
          params: { code: product.code }
        } | cxUrl
      "
          >
          <cx-media [container]="product.images.PRIMARY" format="product"> </cx-media>
          <div class="name">
            {{ product.name }}
          </div>
          @if (product.ekPrice) {
            <div class="price">
              {{ "productDetails.ekPrice" | cxTranslate }}
              {{ product.ekPrice.formattedValue }}
            </div>
          }
        </span>
      }
    }
  </div>
}
